document.addEventListener('DOMContentLoaded', function () {

  var main = new Splide( '.clean-design-v2 .mainProduct-gallery', {
    type: 'slide',
    pagination: false,
    arrows    : true,
  } );

  var thumbnails = new Splide( '.clean-design-v2 .mainProduct-thumbs', {
    perPage     : 5,
    gap         : 10,
    rewind      : true,
    pagination  : false,
    isNavigation: true,
    arrows    : false,
  } );

  main.sync( thumbnails );
  main.mount();
  thumbnails.mount();

  const tabForms = document.querySelectorAll('.clean-design-v2 .bcolors-form');
  const gift_wrappers = document.querySelectorAll('.clean-design-v2 .bcolors-gift-wrapper');

  const updateProgressBar = (count, progressBar) => {
    const checkpoints = progressBar.querySelectorAll('.progress-bar-checkpoint');
    checkpoints.forEach((checkpoint, index) => {
      const checkIcon = checkpoint.querySelector('div');
      if ( index < count ) {
        checkIcon.classList.add('selected');
      } else {
        checkIcon.classList.remove('selected');
      }
    });
    if ( count ) {
      progressBar.style.setProperty('--progress', count == 3 ? '100%' : ( 16.6666 + ( (count - 1) * 33.33333 ) ) + '%');
    } else {
      progressBar.style.setProperty('--progress', '0%');
    }
  }

  const selectOption = (option) => {
    const form = option.closest('.bcolors-form');
    const formOptions = form.querySelectorAll('.bcolors-tabs-option');
    const optionIndex = Array.from( formOptions ).indexOf(option);
    tabForms.forEach(form => {
      const addToCartBtn = form.querySelectorAll('.bcolors-add-to-cart');
      const variant_selector = form.querySelector('.bcolors-variant-selector select');
      const formOptions = form.querySelectorAll('.bcolors-tabs-option');
      const quantity_input = form.querySelector('input[name="quantity"]');
      const frequency_input = form.querySelector('select.bcolorsFrequencySelect');
      const selectedOption = formOptions[optionIndex];
      formOptions.forEach(o => o.classList.remove('selected'));
      selectedOption.classList.add('selected');
      const selectedPrice = selectedOption.querySelector('.final-price').textContent;
      addToCartBtn.forEach(btn => {
        const currentText = btn.textContent;
        const strippedText = currentText.replace(/[\d$.]/g, '');
        btn.textContent = strippedText + selectedPrice;
        if ( option.dataset.soldOut == 'true' ) {
          btn.disabled = true;
          btn.classList.add('sold-out');
          btn.textContent = 'Sold Out';
        } else {
          btn.disabled = false;
          btn.classList.remove('sold-out');
        }
      });
      let selling_plan_id = '';
      if ( option.dataset.sellingPlan ) {
        selling_plan_id = frequency_input ? frequency_input.value : option.dataset.sellingPlan;
      }

      const variant_id_input = form.querySelector('.ptabs-variant-id');
      const selling_plan_id_input = form.querySelector('.ptabs-selling-plan');
      variant_id_input.value = variant_selector ? variant_selector.value : selectedOption.dataset.variantId || '';
      selling_plan_id_input.value = selling_plan_id;
      if ( quantity_input ) quantity_input.value = option.dataset.quantity || '1';
    });
    
    const selectedTab = form.querySelector('.bcolors-tabs-titles button.selected');

     gift_wrappers.forEach(gift_wrapper => {
      const progressBar = gift_wrapper.nextElementSibling;
      giftCount = 0;
      gift_wrapper.querySelectorAll('.bcolors-gift').forEach((gift, index) => {
        if ( option.dataset['gift' + ( index + 1 )] ) { 
          gift.classList.add('unlocked');
          giftCount++;
        } else { 
          gift.classList.remove('unlocked');
        }
      });

      if ( selectedTab && selectedTab.dataset.purchaseType == 'otp' ) {
        gift_wrapper.classList.add('otp');
      } else {
        gift_wrapper.classList.remove('otp');
      }

      if ( giftCount ) {
        gift_wrapper.classList.remove('empty');
      } else {
        gift_wrapper.classList.add('empty');
      }

      if ( progressBar ) {
        updateProgressBar(giftCount, progressBar);
      }
    });

    const option_image = option.querySelector('img');
    if ( option_image ) {
      thumbnails.go(0);
      const firstSlide = document.querySelector('#mainProduct-gallery .splide__slide:first-child img');
      firstSlide.src = option_image.src;
      firstSlide.srcset = '';
    }
  }

    
  gift_wrappers.forEach(gift_wrapper => {
    giftList = gift_wrapper.querySelectorAll('.bcolors-gift');
    giftList.forEach((gift, index) => {
      gift.addEventListener('click', function() {
        const gift_wrapper = this.closest('.bcolors-gift-wrapper');
        const selectedTab = document.querySelector('.bcolors-tabs-titles button.selected');
        const isOtp = selectedTab && selectedTab.dataset.purchaseType == 'otp';
        const gift = gift_wrapper.querySelectorAll('.bcolors-gift')[index];
        let popupLink = gift.dataset.popupLink;
        if ( isOtp ) {
          const popupLinkOtp = gift.dataset.popupLinkOtp;
          if ( popupLinkOtp ) {
            popupLink = popupLinkOtp;
          } else {
            return;
          }
        }
        if ( popupLink ) {
          const popup = document.getElementById(popupLink);
          if ( popup ) {
            document.body.classList.add('freebie-popup-open');
            popup.classList.add('open');
          }
        }

        if ( isOtp ) return;
        const progressBar = gift_wrapper.nextElementSibling;
        if ( progressBar.classList.contains('bcolors-progress-bar') && progressBar.style.display != 'none' ) {
          selectGift(index);
        }
        
      });
    });
  });

  const bogusPopupButton = document.querySelector('.bcolors-bogus-popup-text');
  if ( bogusPopupButton ) {
    bogusPopupButton.addEventListener('click', function() {
      let popupLink = bogusPopupButton.dataset.popupId;
      const popup = document.getElementById(popupLink);
      if ( popup ) {
        document.body.classList.add('bogus-popup-open');
        popup.classList.add('open');
      }
    });
  }

  const selectGift = ( index ) => {

    gift_wrappers.forEach(gift_wrapper => {
      giftList = gift_wrapper.querySelectorAll('.bcolors-gift');
      const progressBar = gift_wrapper.nextElementSibling;
      updateProgressBar(index + 1, progressBar);
      giftList.forEach((o, i) => {
        if ( i <= index ) {
          o.classList.add('unlocked');
        } else {
          o.classList.remove('unlocked');
        }
      });
    });
      
    const tabForm = document.querySelector('.clean-design-v2 .bcolors-form');
    const optionSelectors = tabForm.querySelectorAll('.bcolors-tabs-option');
    selectOption(optionSelectors[index]);
  }

  tabForms.forEach(form => {
    const tabSelectors = form.querySelectorAll('.bcolors-tabs-titles button');
    const tabContents = form.querySelectorAll('.bcolors-tabs-panel');
    const variant_id_input = form.querySelector('.ptabs-variant-id');
    const selling_plan_id_input = form.querySelector('.ptabs-selling-plan');

    const optionSelectors = form.querySelectorAll('.bcolors-tabs-option');
    const variant_selector = form.querySelector('.bcolors-variant-selector select');
    const frequency_selector = form.querySelector('select.bcolorsFrequencySelect');

    optionSelectors.forEach(option => {
      option.addEventListener('click', function () {
        optionSelectors.forEach(o => o.classList.remove('selected'));
        selectOption(this);
      });
      if ( option.classList.contains('selected') ) {
        selectOption(option);
      }
    });

    tabSelectors.forEach(tab => {
      tab.addEventListener('click', function () {
        if ( tab.classList.contains('selected') ) return;
        const index = Array.from(tabSelectors).indexOf(this);
        let currentSelectedIndex = 0;
        tabContents.forEach(content => {
          if ( content.classList.contains('selected') ) {
            const optionSelectorsPrev = content.querySelectorAll('.bcolors-tabs-option');
            const selectedOptionPrev = content.querySelector('.bcolors-tabs-option.selected');
            const selectedOptionPrevIndex = Array.from(optionSelectorsPrev).indexOf(selectedOptionPrev);
            currentSelectedIndex = selectedOptionPrevIndex;
          }
        });

        tabForms.forEach(form => {
          const tabContents = form.querySelectorAll('.bcolors-tabs-panel');
          tabContents.forEach(content => {
            if ( content.classList.contains('selected') ) {
              content.classList.remove('selected');
            }
          });
          const tabSelectors = form.querySelectorAll('.bcolors-tabs-titles button');
            tabSelectors.forEach(t => t.classList.remove('selected'));
          tabSelectors[index].classList.add('selected');
          const selectedTab = tabContents[index];
          selectedTab.classList.add('selected');
        });

        const selectedTab = tabContents[index];
        selectedTab.classList.add('selected');
        const optionSelectorsCurrent = selectedTab.querySelectorAll('.bcolors-tabs-option');
        selectOption(optionSelectorsCurrent[currentSelectedIndex]);
      });
    });

    if ( variant_selector ) {
      variant_selector.addEventListener('change', function() {
        
        const variantSlideList = document.querySelectorAll('#mainProduct-thumbs-list li');
        const featuredMedia = getVariantById( this.value ).featured_media;
        if ( featuredMedia ) {
          const variantImage = variantSlideList[featuredMedia.position - 1]?.querySelector('img');
          if ( variantImage ) {
            const variantLi = variantImage.closest('li');
            const variantIndex = Array.from(thumbnails.Components.Elements.slides).indexOf(variantLi);
            thumbnails.go(variantIndex);
          }
        }
        variant_id_input.value = variant_selector.value;
      });
    }

    if ( frequency_selector ) {
      frequency_selector.addEventListener('change', function() {
        selling_plan_id_input.value = frequency_selector.value;
      });
    }
    
  });

  const tabs = document.querySelectorAll('.clean-design-v2 .mpd_tab');
  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const content = this.querySelector('.mpd_tab-content');
      const isActive = content.style.display === 'block';
      document.querySelectorAll('.mpd_tab-content').forEach(c => {
        c.style.display = 'none';
      });
      tabs.forEach(t => t.classList.remove('selected'));
      content.style.display = isActive ? 'none' : 'block';
      if (!isActive) {
        this.classList.add('selected');
      }
    });
  });

  const nadCtas = document.querySelectorAll('.cta-button');
  if ( nadCtas ) {
    nadCtas.forEach(cta => {
      cta.addEventListener('click', function(e) {
        window.scrollTo({
        top: 0,
        behavior: 'smooth'
        });
        e.preventDefault();
      });
    });
  }

  const yotpoStars = document.querySelectorAll('.clean-design-v2 .yotpo-widget-instance');
  if ( yotpoStars ) {
    yotpoStars.forEach(widget => {
      widget.addEventListener('click', function(e) {
        const reviewsTab = document.querySelector('.custom-reviews-wrapper');
        reviewsTab.scrollIntoView({ behavior: 'smooth' });
        e.preventDefault();
      });
    });
  }

  const freebiePopups = document.querySelectorAll('.pdp-freebie-popup');
  if ( freebiePopups.length ) {
    freebiePopups.forEach(popup => {
      const closeBtn = popup.querySelector('.nad3-close');
      closeBtn.addEventListener('click', function() {
        popup.classList.remove('open');
        document.body.classList.remove('freebie-popup-open');
      });
      popup.addEventListener('click', function(e) {
        if ( e.target.classList.contains('pdp-freebie-popup') ) {
          popup.classList.remove('open');
          document.body.classList.remove('freebie-popup-open');
        }
      });
    });
  }

  const upsellCards = document.querySelectorAll('.nad3-upsell-card');
  if ( upsellCards.length ) {
    upsellCards.forEach(card => {
      card.addEventListener('click', function(e) {
        const popupLink = card.dataset.popupLink;
        if ( popupLink ) {
          gift_wrappers[0].querySelector([`.bcolors-gift[data-popup-link="${popupLink}"]`]).click();
          freebiePopups.forEach(popup => {
            popup.classList.remove('open');
          });
          const popup = document.getElementById(popupLink);
          if ( popup ) popup.classList.add('open');
        }
      });
    });
  }

  const popupCtas = document.querySelectorAll('.pdp-freebie-popup .nad3-cta');
  if ( popupCtas.length ) {
    popupCtas.forEach(cta => {
      cta.addEventListener('click', function() {
        tabForms[0].submit();
      });
    });
  }

  function getVariantById(variantId) {
    return product.variants.find(variant => variant.id == variantId);
  }

});